import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot
} from '@angular/router';
import { MessageService } from 'primeng/api';
import { ScreenSizeService } from '@Shared/services';

@Injectable({ providedIn: 'root' })
class DesktopOnly {
  private screenSizeService = inject(ScreenSizeService);
  private messageService = inject(MessageService);

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    if (this.screenSizeService.isDesktop) {
      return true;
    }

    this.messageService.add({
      severity: 'warn',
      detail: 'Team Manager Available only on Desktop version'
    });
    return false;
  }
}

export const DesktopOnlyGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(DesktopOnly).canActivate(next, state);
};
